<template>
  <Sidebar />
  <Content class="analytics-advertisers-content analytics-big-box">
    <div class="inner inner-box">
      <div style="height: 100%">
        <AnalyticsHeader v-if="store.state.user_data && store.state.user_data.merchant_account_id" :show_check_box="true" />
        <AdBrandProductTable
          label="Advertisers"
          search_placeholder="Search by advertiser"
          :build_statistic_url="buildStatisticUrl"
          :build_list_url="buildListUrl"
          :start_date="start_date"
          :end_date="end_date"
        />
      </div>
    </div>
  </Content>
</template>

<script setup>
import { useStore } from 'vuex';
import Sidebar from '@/components/Sidebar.vue';
import Content from '@/components/ui/Content.vue';
import AnalyticsHeader from '@/components/analytics/AnalyticsHeader.vue';
import AdBrandProductTable from '@/components/analytics/AdBrandProductTable.vue';
import moment from 'moment';
import { computed } from 'vue';

const store = useStore();
const start_date = computed(() => store?.state?.save_analytics_start_date || moment().add(-30, 'days').format('YYYY-MM-DD'));
const end_date = computed(() => store?.state?.save_analytics_end_date || moment().add(-1, 'days').format('YYYY-MM-DD'));

const buildStatisticUrl = ({ base, sortlink, keyword, curated }) =>
  `/analytics/advertiser-analytics-statistic?${base}&is_include_shortlink_data=${sortlink}&keyword=${keyword}&is_include_curation_data=${curated}`;

const buildListUrl = ({ base, page, per_page, sort_key, sort_val, sortlink, keyword, curated }) =>
  `/analytics/advertiser-analytics-list?${base}&page=${page}&per_page=${per_page}&sort_key=${sort_key}&sort_val=${sort_val}&is_include_shortlink_data=${sortlink}&keyword=${keyword}&is_include_curation_data=${curated}`;
</script>

<style lang="scss">
.analytics-advertisers-content {
  .inner {
    height: 100%;
    padding: 24px 48px;
  }
  .data-list-scroll{
    height: calc(98vh - 410px);
  }
}
</style>
